export default function Logo({ className = "", withWordmark = true, variant = "dark" }) {
  const stroke = variant === "light" ? "#F2DFC6" : "#29170C";
  const accent = variant === "light" ? "#C98250" : "#93401D";
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <svg
        width="36"
        height="36"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="shrink-0"
        aria-label="Witali Albrecht Logo"
      >
        <path d="M8 42 Q 14 24 20 10" stroke={stroke} strokeWidth="1.6" strokeLinecap="round" fill="none" />
        <path d="M40 42 Q 34 24 28 10" stroke={stroke} strokeWidth="1.6" strokeLinecap="round" fill="none" />
        <path d="M6 42 H 42" stroke={stroke} strokeWidth="1.2" strokeLinecap="round" opacity="0.5" />
        <circle cx="24" cy="28" r="6" fill={accent} />
      </svg>
      {withWordmark && (
        <div className="leading-tight">
          <div
            className={`font-serif text-[18px] tracking-tight ${
              variant === "light" ? "text-[#F2DFC6]" : "text-[#29170C]"
            }`}
          >
            Witali Albrecht
          </div>
          <div
            className={`text-[9px] tracking-[0.3em] uppercase mt-0.5 ${
              variant === "light" ? "text-[#F2DFC6]/60" : "text-[#937353]"
            }`}
          >
            Psychologische Beratung
          </div>
        </div>
      )}
    </div>
  );
}
